import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class SettlementByRequestComponent extends Component {
  state = {
    settlementByRequestBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "method",
        label: "Method",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "idTPlusX",
        label: "MID",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.25"
      }, {
        name: "name",
        label: "Tags",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "walletBalance",
        label: "Payout Wallet",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        hideColumn: false,
        rightAlign: true,
      },{
        name: "pendingPayouts",
        label: "Pending Payouts",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        hideColumn: false,
        rightAlign: true,
      }, {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "balanceToSettle",
        label: "Balance to Settle",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onMidSelect(index, DATA_TYPES.SETTLEMENT_BY_REQUEST),
        alignSelf: "end",
        disabled: true,
        flexGrow: "0"
      }
    ],
    settlementByRequestBaseFields: [
      [
        {
          name: "currency",
          label: "MID Currency",
          disabled: true,
          fieldType: "input",
          flexGrow: "2",
        },
        {
          name: "availableBalance",
          label: "Total Available Balance",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "requestedSettlement",
          label: "Requested Settlement",
          fieldType: "input",
          flexGrow: "10",
        },
        {
          name: "balanceToSettle",
          label: "Balance to Settle",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "propertyId",
          label: "Status",
          fieldType: "select",
          getOptions: () => this.getOptionsFromState("statuses"),
          items: "statuses",
          flexGrow: "10",
        },
      ],
      [
        { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
        {
          name: "notes",
          label: "Notes",
          fieldType: "textarea",
          flexGrow: "1",
        },
        { fieldType: "button" },
      ]
    ],
    settlementFormByRequestTotal: new Form(
      {
        availableBalance: null,
        requestedSettlement: null,
        balanceToSettle: null,
        propertyId: "",
      },
      [
        {
          name: "propertyId",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "requestedSettlement",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
      ]
    ),
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  };

  populateSettlementByRequestForm = (responseMids, response, controls) => {
    const { settlementByRequestBaseMidRowFields, settlementByRequestBaseFields, settlementFormByRequestTotal } = this.state;
    let SETTLEMENT_BY_REQUEST = [];
    const settlementFormByRequest = [];
    const stateForUpdate = {};

    let availableBalance = 0;
    responseMids.forEach((midInfo) => {
      const midForm = this.getMidRowSettlementByRequestForm(midInfo);
      if (midForm.payoutWalletType !== "") {
        this.addPostValue(midForm, "walletBalance", midForm.payoutWalletType);
      }
      settlementFormByRequest.push(midForm);
      SETTLEMENT_BY_REQUEST.push(settlementByRequestBaseMidRowFields);
      availableBalance += parseFloat(midInfo.availableBalance);
    });

    const notesForm = new Form({
      notes: ""
    }, [{
      name: "notes",
      type: "isString",
      rules: {
        required: false,
      },
    }]);

    Object.assign(settlementFormByRequestTotal, {
      availableBalance: parseFloat((availableBalance).toFixed(2)),
      balanceToSettle: 0,
      propertyId: "18",
      requestedSettlement: parseFloat(response.balanceToSettle).toFixed() || 0,
      currency: controls.currency || "",
      settlementRequestId: response.id
    });
    Object.assign(stateForUpdate, {
      settlementFormByRequestTotal: settlementFormByRequestTotal,
      settlementFormByRequestMids: [...settlementFormByRequest],
      settlementMids: [...settlementFormByRequest]
    });

    SETTLEMENT_BY_REQUEST.push([]);
    SETTLEMENT_BY_REQUEST = SETTLEMENT_BY_REQUEST.concat(settlementByRequestBaseFields);
    this.updateField(DATA_TYPES.SETTLEMENT_BY_REQUEST, SETTLEMENT_BY_REQUEST);
    settlementFormByRequest.push(new Form(), settlementFormByRequestTotal, notesForm);
    Object.assign(stateForUpdate, {
      settlementFormByRequest: settlementFormByRequest
    });
    return stateForUpdate;
  };

  getMidRowSettlementByRequestForm = (midInfo) => {
    const { getTXValue } = this.props;
    return new Form(
      {
        id: midInfo.id,
        idTPlusX: `${midInfo.id} (T+${getTXValue(midInfo.id)})`,
        name: midInfo.name,
        method: midInfo.method,
        provider: midInfo.providerName,
        walletBalance: parseFloat(midInfo.walletBalance) || 0,
        payoutWalletType: midInfo.payoutWalletType || "",
        pendingPayouts: parseFloat(midInfo.pendingPayouts) || 0,
        availableBalance: parseFloat(midInfo.availableBalance) || 0,
        balanceToSettle: 0,
        date: midInfo.date || '',
        disabled: false,
        isChecked: false
      },
      [
        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "method",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "pendingPayouts",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "walletBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletType",
          type: "isString",
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        }
      ]
    );
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const { settlementByRequestBaseMidRowFields } = this.state;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, dataType, midIds, settlementId, updateSettlementDate } = controls;
      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }&midIds=${ midIds }&currency=${ controls.currency }&date=${ updateSettlementDate }&id=${ settlementId }`;

      crudActions.get(url)
        .then((response) => {
          crudActions.get(`v1/data/input?clientId=${ merchant }&dataInputTypes=SETTLEMENT_BY_AMOUNT&midIds=${ midIds }&date=${ updateSettlementDate }&currency=${ controls.currency }`)
            .then((midsResponse) => {
              if (midsResponse.length) {
                // Do not display column if value in each row= === 0
                const payoutWalletField = settlementByRequestBaseMidRowFields.find(field => field.name === "walletBalance");
                payoutWalletField.hideColumn = !midsResponse.some(row => row.walletBalance !== 0);
                const pendingPayoutsField = settlementByRequestBaseMidRowFields.find(field => field.name === "pendingPayouts");
                pendingPayoutsField.hideColumn = !midsResponse.some(row => row.pendingPayouts !== 0);
                
                const newState = this.populateSettlementByRequestForm(midsResponse, response, controls);
                Object.assign(newState, {
                  showSecondPanel: true,
                  loadingDataInput: false,
                  lockButton: false,
                });
                this.updateState(newState, settlementByRequestBaseMidRowFields);
              } else {
                this.errorUpdate("There is no available balance on the selected MIDs.");
              }
            }).catch((err) => {
              this.errorUpdate(err ? err.message : "");
            });
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  onSaveDataEntries = () => {
    const { form, formTotal, savedData, settlementMids } = this.props;

    const isFormValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isFormValid, isFormValid && formTotal.balanceToSettle > 0, true);

    const notes = form[form.length - 1].notes;

    if (isFormValid) {
      if (formTotal.balanceToSettle > 0 || formTotal.propertyId === "19") {
        const data = settlementMids.filter(m => (m.isChecked && m.balanceToSettle > 0 && form.propertyId !== "19") || (m.isChecked && form.propertyId === "19")).map((mid) => {
          return {
            id: mid.id,
            name: mid.name,
            method: mid.method,
            walletBalance: mid.walletBalance,
            pendingPayouts: mid.pendingPayouts,
            availableBalance: mid.availableBalance,
            balanceToSettle: mid.balanceToSettle,
            currency: formTotal.currency,
            date: mid.date,
            midId: mid.id,
            clientId: savedData.merchant,
            propertyId: formTotal.propertyId,
            notes
          };
        });
        if (!data.length) {
          this.errorUpdate('Please select a mid - even if you intend to cancel a settlement.');
          return;
        }
        const requestData = {
          settlements: data,
          id: formTotal.settlementRequestId,
          amount: formTotal.requestedSettlement,
          propertyId: formTotal.propertyId
        };
        crudActions.post(`v1/data/input/settlements/submit`, requestData)
          .then(() => {
            this.afterSuccessSave(formTotal.propertyId === "19" ? "Settlement cancelled." : "Settlement successfully initiated.");
          }).catch((err) => {
            this.errorUpdate(err ? err.message : '');
          });
      } else {
        this.errorUpdate('Please select a mid - even if you intend to cancel a settlement.');
      }
    }
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  addPostValue = (form, fieldName, value) => {
    form[fieldName + "PostValue"] = (
      <span className={ `txValue-inputMask ${value === "N/A" ? 'full-width' : ''}` }>({value})</span>
    );
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default SettlementByRequestComponent;